// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Групи виборців» (Voter groups, ключ `vgrp`, група `constituents`). */
export const voterGroupsManifest: IModuleManifest = {
  key: 'vgrp',
  group: 'constituents',
  slug: 'voter-groups',
  prefix: 'VGR',
  name: { en: 'Voter groups', uk: 'Групи виборців' },
  entities: [
    { key: 'vgrp', slug: 'vgrp', name: { en: 'Voter groups', uk: 'Групи виборців' }, main: true },
    { key: 'vgmeet', slug: 'vgmeet', name: { en: 'Meetings with groups', uk: 'Зустрічі з групами' }, main: false },
  ],
  loadState: () => import('./state/voterGroupsSlice').then((m) => m.voterGroupsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
